"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationLinksTooltip = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyMenuConfigurationLinksTooltip = (data, set_data, selected_link, t) => {
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "flux_tooltip", title: t('Flux.IB') },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Flux.tooltips.IB', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Flux.tooltips.IB' },
                        t('Flux.tooltips.IB'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 10, value: selected_link.current.tooltip_text ? selected_link.current.tooltip_text : '', onChange: evt => {
                            selected_link.current.tooltip_text = evt.target.value;
                            set_data(Object.assign({}, data));
                        } })))));
};
exports.SankeyMenuConfigurationLinksTooltip = SankeyMenuConfigurationLinksTooltip;
